// extracted by mini-css-extract-plugin
export default {"productGrid":"GY-z","centerLink":"HY-z","productSection":"IY-z","item":"JY-z","ctaButton":"KY-z"};